import { getOrgUnits, getUserOrgUnits, getUsers } from '@web/lib/demo/utils';
import { getInterval, groupByPeriod, randomInt, transformToGroupedChartResponse } from '@workalizer/shared/utils';
import { endOfDay, startOfDay } from 'date-fns';
var generateDurationSeconds = function (minHours, maxHours) {
    if (minHours === void 0) { minHours = 1; }
    if (maxHours === void 0) { maxHours = 8; }
    return randomInt(minHours, maxHours) * 3600 + randomInt(0, 45) * 60;
};
var buildPerUserPeriodData = function (periods, users, minHours, maxHours) {
    if (minHours === void 0) { minHours = 1; }
    if (maxHours === void 0) { maxHours = 8; }
    return periods.map(function (period) { return ({
        date: period.date,
        users: users.map(function (user) {
            var _a, _b, _c;
            return ({
                userId: user.id,
                orgUnitId: (_c = (_b = (_a = user.userOrgUnits) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.orgUnit.id) !== null && _c !== void 0 ? _c : null,
                value: generateDurationSeconds(minHours, maxHours)
            });
        })
    }); });
};
export var meetingDurationAnalytic = function (input) {
    var interval = getInterval(input.dateFrom, input.dateTo);
    var dateFrom = startOfDay(input.dateFrom);
    var dateTo = endOfDay(input.dateTo);
    var users = getUsers({
        orgUnitId: input.orgUnitId,
        userId: input.userId
    });
    var allUserOrgUnits = getUserOrgUnits();
    var usersInOrgUnits = allUserOrgUnits
        .filter(function (orgUnit) { return users.some(function (user) { return user.id === orgUnit.userId; }); })
        .map(function (orgUnit) { return ({
        userId: orgUnit.userId,
        orgUnitId: orgUnit.orgUnitId
    }); });
    var usersForTransform = users.map(function (user) { return ({
        id: user.id,
        name: user.name,
        email: user.email
    }); });
    var periods = groupByPeriod([], dateFrom, dateTo, interval);
    var perUserData = buildPerUserPeriodData(periods, users, input.userId ? 2 : 1, input.userId ? 9 : 7);
    if (input.groupByOrgUnit === false) {
        return [
            {
                id: 0,
                title: 'Meetings',
                activities: periods.map(function (period) { return ({
                    date: period.date,
                    count: randomInt(4, 18)
                }); })
            },
            {
                id: 1,
                title: 'Duration',
                activities: perUserData.map(function (period) { return ({
                    date: period.date,
                    count: period.users.reduce(function (sum, user) { return sum + user.value; }, 0)
                }); })
            }
        ];
    }
    if (input.orgUnitId === null && input.groupByOrgUnit === true) {
        var orgUnits = getOrgUnits({});
        return transformToGroupedChartResponse(perUserData, 'orgUnit', orgUnits.map(function (orgUnit) { return ({ id: orgUnit.id, title: orgUnit.title }); }), usersForTransform, usersInOrgUnits);
    }
    return transformToGroupedChartResponse(perUserData, 'user', [], usersForTransform, usersInOrgUnits);
};
